import * as React from 'react'
import { Button, Form, Image, Tab, Tabs, Spinner, Container, Col, Row } from 'react-bootstrap'
import { useParams, useLocation, useHistory } from 'react-router-dom'
import * as _ from 'lodash'
import {  AxiosInstance, uploadFileServer } from '../../utils/RequestMethods'

import config from '../../constants/config'
import images from '../../constants/images'

import { isNumber, copyObject } from '../../utils';
import { WorkerObj, WorkerT } from '../../types/Worker'
import InputPhone from '../../components/InputPhone'
import NumberFormatValidate from '../../components/NumberFormatValidate'
import ButtonLoading from '../../components/ButtonLoading/ButtonLoading'
import JobsWoker from './JobsWoker'

import { JobWorkerT } from '../../types/JobWorker'

import ButtonUploadImage from '../../components/ButtonUploadImage'
import { isNumeric } from '../../utils/utilsT'
import { JobRecordT, JobStatusT, JobT } from '../../types/Job'
import GoogleMapAutoComplete from '../../components/MapBoxAutoComplete/GoogleMapAutoComplete'


const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}


const getJobById = async (jobId: number): Promise<JobT> => {
    return await AxiosInstance.get(`${config.url.jobs}/${jobId}`).then((res) => {
        if (res && res.data) {
            return res.data
        }
        throw new Error("");
    })
}

// interface WorkerType {
//     worker: {
//         ID: Number,
//         meta: {
//             address: string,
//             amount: Number,
//             first_name: string,
//             last_name: string,
//             phone: string,
//             profile_pic: string,
//             rating: Number,
//             role: any
//         }
//     }
// }

const WorkerProfile: React.FunctionComponent<{}> = () => {
    let { id } = useParams()
    let query = useQuery();
    // const location = useLocation()
    const history = useHistory()
    const [worker, setWorker] = React.useState(Object.assign({}, WorkerObj))
    // let [rating, setRating] = React.useState(100)
    let [jobs, setJobs] = React.useState<Array<JobT>>([])
    let [amount, setAmount] = React.useState(0)
    const [isReady, setIsReady] = React.useState(false);
    const [dirty, setDirty] = React.useState({})
    const [isNewWorker, setIsNewWorker] = React.useState(false);
    const [showAlertDelete, setShowAlertDelete] = React.useState(false);
    const [fetchIsError, setFetchIsError] = React.useState(false);
    const [fileProfilePic, setFileProfilePic] = React.useState(null)
    const [jobsIsReady, setJobsIsReady] = React.useState(false);
    React.useEffect(() => {

        setIsNewWorker(query.get("new-worker") == "true" ? true : false)
        queryWorkerFromDB()
    }, [])  // TODO: @rating needs to be updated and FIXED here

    let getColorRate = () => {

    }
    const formattedRating = (rating: number): JSX.Element => {
        let color
        console.log("rating", rating)
        if (rating < 60) {
            color = 'red'
        } else {
            color = (rating >= 60 && rating < 80) ? 'orange' : "green"
        }



        return (
            <span style={{ color: color }}>
                {parseFloat(`${rating}`).toFixed(2)}
            </span>
        )
    }

    const queryWorkerFromDB = async (): Promise<any> => {
        setIsReady(false)
        let args = {
            _embed: true,// get jobs with details in _embedded
            // worker_id: id,
            // type: "get_worker_jobs"
        }
        let options={
          data:args
        }
        await AxiosInstance.get(`${config.url.workers}/${id}`, options).then((res) => {
            if (res && res.data && res.status == 200) {
                let cloneWorker = copyObject(res.data)
                // setRating(cloneWorker.rating)
                setAmount(cloneWorker.amount)
                // setJobs(cloneWorker.jobs)
                // fetchAllJobs(cloneWorker.jobs)
                setJobs(extractJobsFromResponse(res.data))
                setTimeout(() => {
                    setJobsIsReady(true)
                }, 500);

                setWorker(cloneWorker)
                // console.log("Worker", cloneWorker)
            }
            setIsReady(true)

        }).catch((error) => {
            setIsReady(true)
            setFetchIsError(true)
            console.log("error" + error)
        })
    }


    const extractJobsFromResponse = (responseData): Array<JobT> => {
        if (_.has(responseData, "_embedded.jobs") && _.isArray(responseData._embedded.jobs) && responseData._embedded.jobs.length > 0) {
            return responseData._embedded.jobs[0];
        }

        return []
    }
    const fetchAllJobs = async (JobWorker: Array<JobRecordT>): Promise<void> => {
        let res = await Promise.all(JobWorker.map(item => getJobById(item.id)))
        setJobs(res)
        setJobsIsReady(true)
    }


    const goToWorkers = (): void => {
        history.push({
            pathname: `/workers`
        })
    }


    /**
     *
     * @param jobs
     * @returns
     */
    const getJobsCompleted = (jobs: Array<JobT>): Array<JobT> => {
        return jobs.filter((job => job.jobStatus == JobStatusT.completed))
    }
    /**
     *
     * @param jobs
     * @returns
     */
    const averageManagerRating = (jobs: Array<JobT>): number => {
        let jobCompelete = getJobsCompleted(jobs)
        if (jobCompelete.length <= 0) {
            return 0
        }
        let rating = 0
        jobCompelete.map((job, index) => {
            job.crew.map((workerCrew, index) => {
                if (workerCrew.id == id) {

                    const workerRating = Number(workerCrew.rating)
                    // console.log("workerRating", workerRating)
                    rating = rating + workerRating
                }
            })
        })

        const total = jobCompelete.length * 5
        let average = (rating * 100) / total
        return average
    }
    /**
      *
      * @returns
      */
    const deleteWorker = async (): Promise<string> => {
        let url = `${config.url.workers}/${id}`
        try {

            let res = await AxiosInstance.delete(url)
            if (res && res.data) {
                setTimeout(() => {
                    goToWorkers()
                }, 1000);
                return "Worker deleted."
            }
            throw "Worker deletion failed.";
        } catch (error) {
            throw error;

        }
    }




    /**
     *
     * @param params
     * @returns
     */
    const save = async (params = null) : Promise<string> => {
        if (!params) {
            params = { ...dirty }
        }
        console.log('params', params)
        console.log('params', dirty)
        try {
            let res = await AxiosInstance.post(`${config.url.workers}/${worker.id}`, params)
            if (res && res.data) {
                // setRating(res.data.rating)
                setAmount(res.data.amount)
                fetchAllJobs(res.data.jobs)
                setWorker(res.data)
                return 'Worker saved.'
            }
        } catch (error) {
            console.log('FALSE: ', error) // TODO - Implement elegant error handling / feedback to user here
            throw new Error(error)

        }
    }

    const onChangeFields = (key: string, value: any) => {
        let cloneDirty = copyObject(dirty)
        cloneDirty[key] = value
        setDirty(cloneDirty)
    }


    const addWorker = (): void => {
        history.push({
            pathname: '/workers/new-worker'
        })
    }


    const saveProfilePicture = async (event): Promise<string> => {
        try {
            const res = await uploadFileServer(fileProfilePic)
            if (res.source_url) {
                onChangeFields('profilePic', res.source_url)
                let params = {
                    profilePic: res.source_url
                }
                const resSave = await save(params)
                if (resSave) {
                    setTimeout(() => {
                        setFileProfilePic(null)
                    }, 1000);
                    return "Profile Pic saved."
                }
            }
        } catch (error) {
            throw new Error(error)
        }
    }

    if (!isReady) {
        return (
            <Container className="mt-5 ">
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <span>Loading...</span>
                    <Spinner animation="border" variant="success" />
                </div>
            </Container>
        )
    }
    if (fetchIsError) {
        return (
            <Container className="mt-5 text-center">
                <div className="alert alert-danger d-flex flex-column">
                    <span>Sorry, not found this worker.</span>
                    <Button onClick={goToWorkers}>Go to workers</Button>
                </div>
            </Container>
        )
    }
    return (
        <div>

            {/* {!isReady && <Container className="mt-5 text-center">
                <Spinner animation="border" variant="success" /> Loading...
                </Container>
            } */}
            {isReady && <> <div style={{ display: 'grid', gridTemplateColumns: '1fr 3fr' }}>
                <div>

                    <Image
                        src={fileProfilePic && fileProfilePic.uri ? fileProfilePic.uri : worker.profilePic != '' ? worker.profilePic : images.noProfilePic}
                        style={{ width: 200, height: 200 }} />
                    <br />

                    <ButtonUploadImage
                        type="button"

                        accept={"image/png, image/jpeg"}
                        className="btn-link  mt-2"
                        onChangeFile={(file) => {
                            setFileProfilePic(file)
                        }}>
                        Edit Profile Image
                    </ButtonUploadImage>
                    {fileProfilePic && <div>
                        <Button variant="light"
                            onClick={() => {
                                setFileProfilePic(null)
                            }}>
                            Cancel</Button>
                        <ButtonLoading
                            className="btn-primary"
                            onClickFetching={saveProfilePicture}>
                            Save</ButtonLoading>
                    </div>}


                </div>
                <div>
                    <Row>
                        <Form.Group as={Col} controlId="firstname">
                            <Form.Control
                                className='input-material'
                                onChange={(event: any) => { onChangeFields('firstName', event.target.value) }}
                                placeholder='First Name'
                                style={{ fontSize: 33 }}

                                value={`${_.has(dirty, "firstName") ? dirty['firstName'] : worker.firstName}`} />
                        </Form.Group>
                        <Form.Group as={Col} controlId="lastname">
                            <Form.Control
                                className='input-material'
                                onChange={(event: any) => { onChangeFields('lastName', event.target.value) }}
                                placeholder='Last Name'
                                style={{ fontSize: 33 }}

                                value={`${_.has(dirty, "lastName") ? dirty['lastName'] : worker.lastName}`} />
                        </Form.Group>
                    </Row>


                    <Row>
                        <Form.Group as={Col} controlId="phone">
                            <InputPhone
                                numberFormat={true}
                                placeholder='Phone'
                                className="input-material"

                                defaultValue={`${_.has(dirty, "phone") ? dirty['phone'] : worker.phone}`}
                                value={`${_.has(dirty, "phone") ? dirty['phone'] : worker.phone}`}

                                onChangePhone={val => {
                                    onChangeFields('phone', val)
                                }}
                                onChangeValue={val => {
                                    // console.log("val", val)
                                    // changeTextInput('phone', val)
                                }} />

                        </Form.Group>

                        <Form.Group as={Col} controlId="email">
                            <Form.Control
                                className='input-material'
                                onChange={(event: any) => { onChangeFields('email', event.target.value) }}
                                placeholder='Email'
                                value={`${_.has(dirty, "email") ? dirty['email'] : worker.email}`} />
                        </Form.Group>
                    </Row>
                    <Row>
                        <Form.Group as={Col} controlId="address">
                            <GoogleMapAutoComplete
                                idAddresss="address_From"
                                className='input-material'
                                apiKey={config.keyMap}
                                onChangeText={text => { }}
                                onPress={async location => {
                                    // let w = { ...worker }
                                    // w.address = location.verbose_address
                                    onChangeFields('address', location.verbose_address)
                                }}

                                placeholder='Address'
                                textValue={`${_.has(dirty, "address") ? dirty['address'] : worker.address}`}
                            />


                        </Form.Group>
                        <Form.Group as={Col} controlId="address2">

                            <Form.Control
                                className='input-material'
                                onChange={(event: any) => { onChangeFields('address2', event.target.value) }}
                                placeholder='Unit'
                                value={`${_.has(dirty, "address2") ? dirty['address2'] : worker.address2}`} />
                        </Form.Group>
                    </Row>

                    <div>
                        <div>
                            <Form.Label>Hourly Rate, $/hr</Form.Label>
                            <NumberFormatValidate
                                customInput={Form.Control}
                                className="input-material"
                                type="text"
                                defaultValue={`${worker.hourlyRate}`}

                                value={`${_.has(dirty, "hourlyRate") ? dirty['hourlyRate'] : worker.hourlyRate}`}
                                onValueChange={(values) => {
                                    const { formattedValue, value, floatValue } = values;
                                    onChangeFields('hourlyRate', floatValue)
                                }}
                                mask="_"

                                prefix={'$'}
                                fixedDecimalScale={true}
                                decimalScale={2}
                            />
                        </div>
                    </div>
                    <div>

                    </div>
                    <div>
                        <strong>Rating: {formattedRating(averageManagerRating(jobs))}%</strong>
                        &nbsp;over {getJobsCompleted(jobs).length} completed jobs.

                    </div>

                    <div className="d-flex flex-column">
                        {(worker.jobs.length <= 0 && showAlertDelete) && <div className="alert alert-danger d-flex flex-column">

                            <span>Are you sure you want to delete this worker?</span>
                            <div className=" d-flex flex-row">
                                <Button variant="light" onClick={() => { setShowAlertDelete(false) }}>Cancel</Button>
                                <ButtonLoading
                                    type="button"

                                    onClickFetching={deleteWorker}
                                    className="btn-outline-danger ">Delete Worker</ButtonLoading>
                            </div>

                        </div>}
                        <div className="d-flex flex-row mt-2">
                            <ButtonLoading
                                style={{ marginLeft: 0 }}
                                className="btn-success"
                                onClickFetching={async (e): Promise<string> => {
                                    return await save()
                                }}>Save</ButtonLoading>

                            {worker.jobs.length <= 0 &&
                                <Button variant="outline-danger" disabled={showAlertDelete} onClick={() => { setShowAlertDelete(true) }}>Delete Worker</Button>}

                            {isNewWorker && <Button
                                onClick={addWorker}
                                variant='outline-info'>
                                Add Another
                            </Button>}
                        </div>

                    </div>

                </div>
            </div>

                <div className="p-1">
                    <Tabs defaultActiveKey="jobs" id="workerProfileTabs" variant="pills">
                        <Tab eventKey="jobs" title="Jobs">
                            <JobsWoker worker={worker} jobs={jobs} jobsIsReady={jobsIsReady} />
                        </Tab>
                        <Tab eventKey="calendar" title="Schedule">
                            <br />
                            <Form.Control />
                        </Tab>
                        <Tab eventKey="equipment" title="Equipment">

                        </Tab>
                    </Tabs>
                </div>
            </>}
        </div>
    )
}

export default WorkerProfile
